import { ReactComponent as Chevron } from "./chevron-up.svg";
import { useState } from "react";

function DetailBox(props) {
  const [isOpen, setIsOpen] = useState(false);

  function displayContent() {
    setIsOpen(!isOpen);
  }
  return (
    <div className="detail-box">
      <header className="detail-box__header">
        <h2 className="content-description">{props.title}</h2>
        <div className="button-wrapper">
          <Chevron
            className={
              isOpen === false ? "chevron-button reverse" : "chevron-button"
            }
            onClick={() => displayContent()}
          />
        </div>
      </header>
      <div
        className={
          isOpen === false
            ? "detail-box__contents hide"
            : "detail-box__contents"
        }
      >
        <p className="detail-box__contents__text">{props.content}</p>
      </div>
    </div>
  );
}

export default DetailBox;
